import { ContentCopy } from '@mui/icons-material';
import { IconButton, Skeleton, Tooltip, styled, tooltipClasses } from '@mui/material';
import { ReactNode, useState } from 'react';

const StyledCodeSection = styled('div')({
  borderRadius: '4px',
  background: '#F6F6F6',
  color: '#4A495CCC',
  fontSize: '12px',
  fontWeight: '500',
  lineHeight: '18px',
  letterSpacing: '-0.02em',
  textAlign: 'left',
  padding: '4px 8px',
  whiteSpace: 'pre-line',
  wordBreak: 'break-word',
  minHeight: '21px',
});

const LoadingSkeleton = () => <Skeleton height={100} />;

interface IProps {
  content: string | null | undefined;
  label: ReactNode;
  loading?: boolean;
}

const CodeSection = ({ content, label, loading }: IProps) => {
  const [open, setOpen] = useState<boolean>(false);

  const onCopyClick = () => {
    if (content) {
      navigator.clipboard.writeText(content);
      setOpen(true);
      setTimeout(() => setOpen(false), 700);
    }
  };

  return (
    <div className='mt-2 border rounded-md p-[10px]'>
      <div className='flex justify-between items-center mb-1'>
        <span className='font-semibold text-[12px]'>{label}</span>
        {!loading ? (
          <Tooltip
            title='Copied'
            open={open}
            placement='top'
            sx={{
              [`&.${tooltipClasses.tooltip}`]: {
                padding: '4px 8px',
              },
            }}
          >
            <IconButton aria-label='copy' onClick={onCopyClick}>
              <ContentCopy sx={{ width: '12px', height: '12px' }} />
            </IconButton>
          </Tooltip>
        ) : null}
      </div>
      {!loading ? <StyledCodeSection>{content}</StyledCodeSection> : <LoadingSkeleton />}
    </div>
  );
};

export default CodeSection;
